export interface InfeasibilityConstraint {
    constraint_name: string;
    infeasible: boolean;
}

export interface InfeasibilityConstraintGroup {
    constraint_group: string;
    infeasible: boolean;
    constraints: InfeasibilityConstraint[];
}

export enum InfeasibilityStatus {
    IDLE = 'idle',
    POLLING = 'polling',
    COMPLETED = 'completed',
    ERROR = 'error',
}
